<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'ChartsextraPie',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.resize)
  // },
  methods: {
    // resize() {
    //   this.mychart.resize()
    // },
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)

      let legendData = []
      let rateData = []
      let rateArr = []
      let counts = 100
      let rateStr = ''
      if (this.data) {
        legendData = this.data.name
        if (this.data.Counts) {
          counts = Number(this.data.Counts)
        } else {
          counts = 100
        }
      }

      if (this.data.data) {
        rateStr = this.data.data.join()
        if (rateStr.indexOf('%') > -1) {
          rateArr = rateStr.replace('%', '').split()
          rateData = rateStr.replace('%', '').split()
        } else {
          rateData = []
          rateData = rateStr.split()
        }
      }
      var option = {
        title: [
          {
            text: legendData,
            x: 'center',
            top: '55%',
            textStyle: {
              color: '#000',
              fontSize: 14,
              fontWeight: '400'
            }
          },
          {
            text: rateArr.length > 0 ? rateData + '%' : rateData,
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: '16',
              color: '#000',
              fontFamily: 'DINAlternate-Bold, DINAlternate',
              foontWeight: '600'
            }
          }
        ],
        backgroundColor: '#fff',
        polar: {
          radius: ['42%', '52%'],
          center: ['50%', '50%']
        },
        angleAxis: {
          max: counts,
          show: false
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            roundCap: true,
            barWidth: 30,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(66, 66, 66, .3)'
            },
            data: rateData,
            coordinateSystem: 'polar',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#667eea'
                  },
                  {
                    offset: 1,
                    color: '#764ba2'
                  }
                ])
              }
            }
          },
          {
            name: '',
            type: 'pie',
            startAngle: 80,
            radius: ['56%'],
            hoverAnimation: false,
            center: ['50%', '50%'],
            itemStyle: {
              color: 'rgba(66, 66, 66, .1)',
              borderWidth: 1,
              borderColor: '#5269EE'
            },
            data: [counts]
          },
          {
            name: '',
            type: 'pie',
            startAngle: 80,
            radius: ['38%'],
            hoverAnimation: false,
            center: ['50%', '50%'],
            itemStyle: {
              color: 'rgba(66, 66, 66, .1)',
              borderWidth: 1,
              borderColor: '#5269EE'
            },
            data: [counts]
          }
        ]
      }
      mychart.setOption(option)
    }
  }
}
</script>
